import { Component, Input, input, OnInit } from "@angular/core";
import LocalizationConstants from "src/app/constants/localization-constants";
import { Address } from "src/app/models/Address";
import CustomerSettings from "src/app/models/CustomerSettings";
import { ParcelOption, ParcelOptionsWithLabels } from "src/app/models/ParcelDimensionsOption";
import { ServiceRequest } from "src/app/models/ServiceRequest";
import { ShipmentPickupDetails } from "src/app/models/ShipmentPickupDetails";
import { getUnitTranslations } from "src/app/utils/measures.utils";
import { getDimensionsLabel } from "src/app/utils/parcels.utils";

@Component({
  selector: "final-step-main-content",
  templateUrl: "./final-step-main-content.component.html",
  styleUrls: ["./final-step-main-content.component.scss"],
  standalone: false,
})
export class FinalStepMainContentComponent implements OnInit {
  @Input() ra: ServiceRequest;
  @Input() currentShipFrom: Address;
  @Input() companyName: string;
  @Input() customerSettings: CustomerSettings;

  @Input() shipmentPickupDetails: ShipmentPickupDetails;

  @Input() showShipmentDetails: boolean;

  packages = input<ParcelOption[]>([]);

  vendorNameToShow = input<string>("");

  readonly localizationConstants = LocalizationConstants;

  getDimensionsLabel = getDimensionsLabel;

  parcelOptionsWithLabels = ParcelOptionsWithLabels;
  lengthUnitTranslation: string;
  weightUnitTranslation: string;

  ngOnInit() {
    this.setUnitTranslations();
  }

  setUnitTranslations() {
    if (!this.customerSettings?.unitOfMeasure) return;
    const unitTranslations = getUnitTranslations(this.customerSettings.unitOfMeasure);
    this.lengthUnitTranslation = unitTranslations.lengthUnitTranslation;
    this.weightUnitTranslation = unitTranslations.weightUnitTranslation;
  }
}
